import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import '../checkout.css';
import _ from 'lodash';
import validate from 'validate.js';

const validateFurtherInformation = {
    name: {
        presence: { allowEmpty: false, message: 'is required' },
    },
    lastName: {
        presence: { allowEmpty: false, message: 'is required' },
    },
    email: {
        presence: { allowEmpty: false, message: 'is required' },
        email: {
            message: "is invalid email."
        }
    },
    phoneNumber: {
        presence: { allowEmpty: false, message: 'is required' },
        numericality: { onlyInteger: true },
        format: /\d{10}/
    }
}

class CheckOutDialogEmail extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            values: {
                email: '',
                name: '',
                lastName: '',
                phoneNumber: ''
            },
            touched: [],
            error: {
                status: true,
                message: {}
            },
            fields: []
        }
    }

    handleChangeData = (e) => {
        e.persist();
        const { name, value } = e.target;
        let field = name == "firstname" ? "name": name
        this.setState({ 
            values: { 
                ...this.state.values, 
                [field]: value 
            },
            touched: [ ...this.state.touched, field ]
        });
    }

    componentDidMount() {
        this.handleSetValues();
        const { values } = this.state;
        this.setState({ 
            fields: Object.keys(values) 
        });
    }

    componentDidUpdate(prevProps, prevState) {

        if (!_.isEqual(prevState.values, this.state.values)) {
            const { values, fields } = this.state;
            const error = validate(
                values, 
                fields.reduce((acc, cur) => ({ ...acc, [cur]: validateFurtherInformation[cur] }), {})
            );
            const _isValid = error ? true: false;
            this.setState({ 
                error: {
                    status: _isValid,
                    message: error || {}
                }
            });
        }

        if (
            !_.isEqual(prevProps.firebaseAuth, this.props.firebaseAuth)
            || !_.isEqual(prevProps.dataShipping, this.props.dataShipping)
            || !_.isEqual(prevProps.isAuthenticated, this.props.isAuthenticated)
        ) {
            this.handleSetValues();
        }
    }

    handleSetValues = () => {
        const { dataShipping, isAuthenticated, firebaseAuth } = this.props;
        const email = dataShipping?.email
            ? dataShipping.email
            : isAuthenticated
                ? (firebaseAuth?.email || "")
                : "";
        const spliteName = isAuthenticated ? firebaseAuth?.displayName?.split(" "): null;
        const name = dataShipping?.name
            ? dataShipping.name
            : isAuthenticated
                ? (
                    spliteName 
                        ? spliteName[0]
                        : ""
                )
                : "";
        const lastName = dataShipping?.lastName
            ? dataShipping.lastName
            : isAuthenticated
                ? (
                    spliteName 
                        ? spliteName[1]
                        : ""
                )
                : "";
        const phoneNumber = dataShipping?.phoneNumber
            ? dataShipping.phoneNumber
            : "";
        this.setState({
            values: {
                email,
                name,
                lastName,
                phoneNumber
            }
        });
    }

    hasError = (field) => {
        const { error, touched } = this.state;
        return error.message.hasOwnProperty(field) && touched.includes(field);
    }

    hasProps = (field) => {
        const { fields } = this.state;
        return fields.includes(field);
    }

    render() {
        const {
            dialogFurtherInformation,
            CloseDialogFurtherInformation,
            wording,
            applyFormChange,
            shipping
        } = this.props;
        const {
            values,
            error,
            fields
        } = this.state;
        const { email, name, lastName, phoneNumber } = values;

        return (
            <Modal
                visible={dialogFurtherInformation}
                width='450'
                effect='fadeInUp'
                onClickAway={() => CloseDialogFurtherInformation()}>
                <div className='m-20'>
                    <div className='dialog-header'>
                        <h4 style={{ color: '#2d64cf' }}>
                            {wording.checkoutPage.dialogFurtherInformation.title}
                        </h4>
                    </div>
                    <div className='dialog-body mt-20 mb-20'>
                        {
                            this.hasProps("name") &&
                                <div>
                                    <label htmlFor="input-name">{wording.checkoutPage.dialogFurtherInformation.name}</label>
                                    <input
                                        id="input-name"
                                        name='firstname'
                                        type='text'
                                        placeholder={wording.checkoutPage.dialogFurtherInformation.name}
                                        autoComplete="on"
                                        value={name}
                                        onChange={this.handleChangeData}
                                    />
                                    {this.hasError("name") && (
                                        <p className='error'>
                                            {error.message.name?.join(", ")}
                                        </p>
                                    )}
                                </div>
                        }
                        {
                            this.hasProps("lastName") &&
                                <div>
                                    <label htmlFor="input-lastname">{wording.checkoutPage.dialogFurtherInformation.lastname}</label>
                                    <input
                                        id="input-lastname"
                                        name='lastName'
                                        type='text'
                                        placeholder={wording.checkoutPage.dialogFurtherInformation.lastname}
                                        autoComplete="on"
                                        value={lastName}
                                        onChange={this.handleChangeData}
                                    />
                                    {this.hasError("lastName") && (
                                        <p className='error'>
                                            {error.message.lastName?.join(", ")}
                                        </p>
                                    )}
                                </div>
                        }
                        {
                            this.hasProps("email") &&
                                <div>
                                    <label htmlFor="input-email">{wording.checkoutPage.dialogFurtherInformation.email}</label>
                                    <input
                                        id="input-email"
                                        name='email'
                                        type='text'
                                        placeholder={wording.checkoutPage.dialogFurtherInformation.email}
                                        autoComplete="on"
                                        value={email}
                                        onChange={this.handleChangeData}
                                    />
                                    {this.hasError("email") && (
                                        <p className='error'>
                                            {error.message.email?.join(", ")}
                                        </p>
                                    )}
                                </div>
                        }

                        {
                            this.hasProps("phoneNumber") &&
                                <div>
                                    <label htmlFor="input-phoneNumber">{wording.checkoutPage.dialogFurtherInformation.phoneNumber}</label>
                                    <input
                                        id="input-phoneNumber"
                                        name='phoneNumber'
                                        type='text'
                                        placeholder={wording.checkoutPage.dialogFurtherInformation.phoneNumber}
                                        autoComplete="on"
                                        value={phoneNumber}
                                        onChange={this.handleChangeData}
                                    />
                                    {this.hasError("phoneNumber") && (
                                        <p className='error'>
                                            {error.message.phoneNumber?.join(", ")}
                                        </p>
                                    )}
                                </div>
                        }

                    </div>

                    <div className='dialog-action row'>
                        <div className='col-xs-6 col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-dark'
                                disabled={error.status}
                                onClick={async () => {
                                    await CloseDialogFurtherInformation();
                                    applyFormChange(fields.reduce((acc, cur) => ({ ...acc, [cur]: values[cur] }), {}));
                                }}>
                                {wording.checkoutPage.dialogFurtherInformation.ok}
                            </button>
                        </div>
                        <div className='col-xs-6 col-md-6'>
                            <button
                                style={{ width: '100%' }}
                                className='btn btn-md btn-light-red'
                                onClick={() => CloseDialogFurtherInformation()}>
                                {wording.checkoutPage.dialogFurtherInformation.cancel}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ checkout, language, login }) => ({
    dialogFurtherInformation: checkout.dialogFurtherInformation,
    wording: language.wording,
    isAuthenticated: login.isAuthenticated,
    firebaseAuth: login.firebaseAuth
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            CloseDialogFurtherInformation: Actions.CloseDialogFurtherInformation
        },
        dispatch
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckOutDialogEmail);
